import { render, staticRenderFns } from "./budget-show-spf-modal.vue?vue&type=template&id=60bda690&"
import script from "./budget-show-spf-modal.vue?vue&type=script&lang=ts&"
export * from "./budget-show-spf-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports